import { Box, Typography, CircularProgress } from '@mui/material'

export const CallbackPage = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="50vh"
      textAlign="center"
      sx={{ p: 3 }}
    >
      <CircularProgress size={60} sx={{ mb: 3, color: 'primary.main' }} />
      
      <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 500 }}>
        Loading Application
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 400 }}>
        Please wait while we load your chat application...
      </Typography>
    </Box>
  )
}
